// extracted by mini-css-extract-plugin
export default {"root":"YfOJf5Ih5fzJAecPuUxg","divider":"bpoT5bCBhLRp1VzUP7G4","statusSelect":"Jaa_Ue9bZ8e3HZmHMsAK"};